import { Component, Input, ChangeDetectionStrategy, OnDestroy, ViewChild, HostListener, inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {PopoverDirective} from 'ngx-bootstrap/popover';
import {timer} from 'rxjs';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TooltipComponent implements OnDestroy {
    private readonly translateService = inject(TranslateService);

    @Input() public text: string;
    @Input() public textParam: unknown;
    @Input() public delay: number;
    @Input() public adaptivePosition: boolean;
    @Input() public position = 'right';
    @Input() public error: boolean;
    @Input() public warning: boolean;
    @Input() public compact: boolean;

    @ViewChild(PopoverDirective) private readonly popoverDirective: PopoverDirective;
    private delayTimer$: any;

    @HostListener('mouseenter') onMouseEnter() {
        if (this.delay) {
            this.delayTimer$ = timer(this.delay).subscribe(() => {
                this.popoverDirective.popover = this.translateService.instant(this.text);
                this.popoverDirective.show();
            });
        }
    }

    @HostListener('mouseleave') onMouseLeave() {
        if (this.delay) {
            this.popoverDirective.popover = '';
            this.popoverDirective.hide();
            this.delayTimer$?.unsubscribe();
        }
    }

    ngOnDestroy(): void {
        this.delayTimer$?.unsubscribe();
    }
}
